"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MfaTypeChamp = void 0;
var MfaTypeChamp = {
  "texte": 0,
  "date": 1,
  "liste": 2,
  "radio": 3,
  "aire": 4,
  "case": 5,
  "commentaire": 6,
  "radioTexteHorizontal": 7,
  "texteMasque": 8,
  "navigationCommentaire": 9,
  "blocPersonalise": 10
};
exports.MfaTypeChamp = MfaTypeChamp;